import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Domain from "@material-ui/icons/Domain";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import AttendanceLocalDepartmentGuicheServiceListTableActions from "./components/table-action";
// import SearchField from "../../../../../../../../../../../components/search-field";
import { useAttendanceLocalStyles } from "../../../../../../../../../../../styles";
import { useAttendanceLocalDepartmentQueueServiceComplementListStyles } from "./styles";
import CustomPagination from "../../../../../../../../../../../../../Components/pagination";
import { dateformat } from "../../../../../../../../../../../../../utils/dateFormat";
import { useBreadcrumbs } from "../../../../../../../../../../../../../contexts/breadcrumb";
import EmptyState from "../../../../../../../../../../../../../Components/EmptyState";
import { useAttendanceLocalDepartmentGuicheServiceComplementList } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/service/complement/list";
import ServiceFormCreate from "../form/create";

export default function AttendanceLocalDepartmentGuicheServiceComplementList() {
    const history = useHistory();
    const { slug, department_id, guiche_id } = useParams<{
        slug: string;
        department_id: string;
        guiche_id: string;
    }>();
    const { setBreadcrumbs } = useBreadcrumbs();
    const { classes } = useAttendanceLocalDepartmentQueueServiceComplementListStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const { data: serviceComplementList, isLoading } = useAttendanceLocalDepartmentGuicheServiceComplementList({
        guiche: Number(guiche_id),
    });

    const isEmpty = (serviceComplementList?.results ?? []).length === 0;

    useEffect(() => {
        setBreadcrumbs((prev) => {
            const homeBreadcrumb = prev.find((_, index) => index === 0);
            return [
                homeBreadcrumb,
                {
                    label: "Locais de Atendimento",
                    path: "/locais-de-atendimento",
                    icon: Domain,
                },
                {
                    label: "Setor",
                    path: `/locais-de-atendimento/${slug}/setor/${department_id}`,
                    icon: Domain,
                },
                {
                    label: "Serviços Complementares do Guichê",
                    path: "",
                }
            ];
        });
    }, [setBreadcrumbs, slug, department_id]);

    return (
        <Box>
            <Box>
                <Button
                    className={classes.backButton}
                    startIcon={<ChevronLeft />}
                    onClick={() => history.goBack()}
                >
                    Voltar
                </Button>
            </Box>
            <Box className={classes.header}>
                <Typography className={classes.title}>
                    Serviços Complementares do Guichê
                </Typography>
                <ServiceFormCreate
                    unidade={slug}
                    setor_unidade={Number(department_id)}
                    guiche_id={Number(guiche_id)}
                />
            </Box>
            <Paper elevation={3} style={{ overflow: "hidden" }}>
                {/* <SearchField /> */}
                <TableContainer className={defaultClasses.tableContainer}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell className={defaultClasses.tableTH}>
                                    Serviço complementar
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Serviço relacionado
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH}>
                                    Adicionado em
                                </TableCell>
                                <TableCell className={defaultClasses.tableTH} />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {serviceComplementList?.results.map((service) => (
                                <TableRow key={service.id} hover>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {service.servico_complementar}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {service.servico_relacionado}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        {dateformat(service.servico.created_at, true)}
                                    </TableCell>
                                    <TableCell className={defaultClasses.tableCell}>
                                        <AttendanceLocalDepartmentGuicheServiceListTableActions
                                            serviceComplement={service}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    {isEmpty && (
                        <EmptyState
                            loading={isLoading}
                            loadingText="Carregando serviços complementares..."
                            message="Nenhum serviço complementar encontrado."
                        />
                    )}
                </TableContainer>
                <Box className={defaultClasses.paginationContainer}>
                    <CustomPagination
                        count={serviceComplementList?.count}
                        page={serviceComplementList?.current}
                        totalPages={serviceComplementList?.total_pages}
                    />
                </Box>
            </Paper>
        </Box>
    );
}
